"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.quote = quote;
exports.quoteForOneDollar = quoteForOneDollar;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ethers = require("ethers");

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var _v3Sdk = require("@uniswap/v3-sdk");

var _Quoter = _interopRequireDefault(require("@uniswap/v3-periphery/artifacts/contracts/lens/Quoter.sol/Quoter.json"));

var _constants = require("./constants");

var _conversion = require("./conversion");

/**
 * 
 * @param {*} rpcProvider 
 * @param {inToken} inToken
 * @param {outToken} outToken  
 * @param {amount} amountIn 
 *    Token(chainId: number, address: string, decimals: number, 
 *    symbol?: string, name?: string, bypassChecksum?: boolean)
 * @returns 
 */
function quoteForOneDollar(_x, _x2, _x3, _x4) {
  return _quoteForOneDollar.apply(this, arguments);
}
/**
 * get quote between two token
 * @param {*} rpcProviders
 * @param {inToken} inToken
 * @param {outToken} outToken  
 * @param {amount} amountIn 
 *    Token(chainId: number, address: string, decimals: number, 
 *    symbol?: string, name?: string, bypassChecksum?: boolean)
 * @returns 
 */


function _quoteForOneDollar() {
  _quoteForOneDollar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(rpcProvider, inToken, outToken, amountIn) {
    var quoterContract, quotedAmountOut, val;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(outToken['address'].toLowerCase() == inToken['address'].toLowerCase())) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", (0, _conversion.fromReadableAmount)(amountIn, inToken.decimals).toString());

          case 2:
            quoterContract = new _ethers.ethers.Contract(_constants.QUOTER_CONTRACT_ADDRESS, _Quoter["default"].abi, rpcProvider); // console.log("1111->", inToken.address,
            //   outToken.address,
            //   outToken['feeAmount'] || FeeAmount.MEDIUM);

            _context.next = 5;
            return quoterContract.callStatic.quoteExactInputSingle(inToken.address, outToken.address, outToken['feeAmount'] || _v3Sdk.FeeAmount.MEDIUM, (0, _conversion.fromReadableAmount)(amountIn, inToken.decimals).toString(), 0);

          case 5:
            quotedAmountOut = _context.sent;
            val = new _bignumber["default"](quotedAmountOut.toString()).toFixed(0); // console.log(amountIn+"  "+ USDT_TOKEN.decimals+"  " + quotedAmountOut+"  " + val +"  decimals=" +outToken.decimals)

            return _context.abrupt("return", val);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _quoteForOneDollar.apply(this, arguments);
}

function quote(_x5, _x6, _x7, _x8) {
  return _quote.apply(this, arguments);
}

function _quote() {
  _quote = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(rpcProviders, inToken, outToken, amountIn) {
    var promisAny, i, quoterContract, promisOne, quotedAmountOut, val;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(outToken['address'].toLowerCase() == inToken['address'].toLowerCase())) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", "" + amountIn);

          case 2:
            promisAny = [];

            for (i = 0; i < rpcProviders.length; i++) {
              quoterContract = new _ethers.ethers.Contract(_constants.QUOTER_CONTRACT_ADDRESS, _Quoter["default"].abi, rpcProviders[i]);
              console.log(i + "=" + rpcProviders[i] + "  in=" + inToken['symbol'] + " out=" + inToken['symbol']);
              promisOne = quoterContract.callStatic.quoteExactInputSingle(inToken.address, outToken.address, outToken['feeAmount'] || _v3Sdk.FeeAmount.MEDIUM, "" + amountIn, 0);
              promisAny.push(promisOne);
            } // console.log(promisAny)


            _context2.next = 6;
            return Promise.any(promisAny);

          case 6:
            quotedAmountOut = _context2.sent;
            val = new _bignumber["default"](quotedAmountOut.toString()).toFixed(0);
            return _context2.abrupt("return", val);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _quote.apply(this, arguments);
}